import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./IntegratedInverter.css";
// import inverterImg from "../../assets/images/inverter-home.png"; 

const IntegratedInverter = () => {
  const navigate = useNavigate();

  const handleExplore = () => {
    navigate("/shop?category=Inverters & Solar");
  };

  // Scroll reveal animation hook
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      { threshold: 0.2 } // Triggers when 20% of the section is visible
    );

    const elementsToAnimate = document.querySelectorAll('.animate-on-scroll');
    elementsToAnimate.forEach((el) => observer.observe(el));

    return () => {
      elementsToAnimate.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <section className="integrated-inverter-section">
      <div className="inverter-container">
        
        {/* LEFT: Text Content */}
        <div className="inverter-content animate-on-scroll slide-right">
          <div className="badge-tech">Zynventics Exclusive</div>
          <h2>Smart Integrated Inverter</h2>
          <p className="subtitle">
            Compact, silent, and engineered for absolute reliability. Designed for modern Indian homes and available in multiple variants to perfectly match your load requirements.
          </p>

          <div className="specs-row">
            <div className="spec-box">
              <span className="spec-val">Compact</span>
              <span className="spec-label">Form Factor</span>
            </div>
            <div className="spec-box">
              <span className="spec-val">1-5 kVA</span>
              <span className="spec-label">Capacity Models</span>
            </div>
            <div className="spec-box">
              <span className="spec-val">98%</span>
              <span className="spec-label">Peak Efficiency</span>
            </div>
          </div>

          <button className="explore-btn" onClick={handleExplore}>
            Explore Models 
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: '8px' }}><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
          </button>
        </div>

        {/* RIGHT: Product Visual */}
        <div className="inverter-visual animate-on-scroll slide-left">
          <div className="circle-bg"></div>
          <img 
            src="https://placehold.co/600x400/1e293b/FFF?text=Zynvert+Home+Inverter" 
            alt="Zynventics Smart Inverter" 
            className="product-img"
          />
          
          {/* Floating Feature Cards with SVGs */}
          <div className="float-card top">
             <div className="float-icon">
               <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/></svg>
             </div>
             <span>Hybrid Solar Ready</span>
          </div>
          <div className="float-card bottom">
             <div className="float-icon">
               <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="14" height="20" x="5" y="2" rx="2" ry="2"/><path d="M12 18h.01"/></svg>
             </div>
             <span>Smart App Control</span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default IntegratedInverter;